import React from 'react'
import { Link } from 'react-router-dom'
import { getDocumentsPageUrl } from '@constants'
import { IDocument, IImportData } from '@query'
import { formatDate } from '@utils'
import BankTransactionHover from './BankTransactionHover'
import { InvoiceDetailField } from './InvoiceDetailField'

interface InvoicePaidAtFieldProps {
  label: string
  isPaid: boolean
  bankTransaction?: IImportData
  paymentDate?: string
}

export const InvoicePaidAtField: React.FC<InvoicePaidAtFieldProps> = ({
  label,
  isPaid,
  bankTransaction,
  paymentDate
}) => {
  if (!isPaid) return null

  if (bankTransaction) {
    return (
      <InvoiceDetailField label={label}>
        <BankTransactionHover importData={bankTransaction}>
          <span>{formatDate(bankTransaction.date)}</span>
        </BankTransactionHover>
      </InvoiceDetailField>
    )
  }

  if (!paymentDate) return null

  return <InvoiceDetailField label={label}>{formatDate(paymentDate)}</InvoiceDetailField>
}

interface InvoiceDocumentLinkFieldProps {
  slug: string
  document?: IDocument
  label: string
  moveToDocumentLabel: string
  moveToDraftLabel: string
}

export const InvoiceDocumentLinkField: React.FC<InvoiceDocumentLinkFieldProps> = ({
  slug,
  document,
  label,
  moveToDocumentLabel,
  moveToDraftLabel
}) => {
  if (!document) return null

  return (
    <InvoiceDetailField label={label}>
      <Link to={getDocumentsPageUrl(slug, { id: document.id })}>
        {document?.number ? `${moveToDocumentLabel} ${document?.number}` : moveToDraftLabel}
      </Link>
    </InvoiceDetailField>
  )
}
